import usersTypes from '../../constants/usersTypes'
import auth_types from '../../constants/authTypes'
export * from './confirm'
export * from './create'
export * from './get'
export * from './getxlsx'
export * from './getindex'
export * from './lock'
export * from './update'

const set_user_errors = (messages) => {
  return {
    type: usersTypes.set_errors,
    payload: messages
  }
}

const reset_user = () => {
  return {
    type: usersTypes.reset_user
  }
}

const clear_user = () => {
  return {
    type: usersTypes.clear_user
  }
}

const update_current_user = (response) => {
  return {
    type: auth_types.set_current_user,
    payload: response.data.user
  }
}

export {
  set_user_errors,
  reset_user,
  clear_user,
  update_current_user
}



// WEBPACK FOOTER //
// ./src/js/actions/users/index.js